import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setK3Tasks } from '../../actions/k3taskAction';
import {
  Modal,
  Form,
  Button,
  Row,
  Col
} from 'react-bootstrap';

class K3TaskCreator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      task_name: '',
      type: 'commit',
      status: 'pending',
      progress: 0,
      agent_ids: '',
      params: '{}',
      output: '{}'
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const taskData = {
        ...this.state,
        agent_ids: this.state.agent_ids.split(',').map(id => id.trim()).filter(Boolean),
        params: JSON.parse(this.state.params),
        output: JSON.parse(this.state.output)
      };
      await this.props.setK3Tasks([taskData]);
      this.props.onHide();
    } catch (error) {
      console.error('Error creating task:', error);
    }
  };

  render() {
    const { show, onHide } = this.props;
    const {
      task_name,
      type,
      status,
      progress,
      agent_ids,
      params,
      output
    } = this.state;

    return (
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Task Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="task_name"
                    value={task_name}
                    onChange={this.handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Type</Form.Label>
                  <Form.Select
                    name="type"
                    value={type}
                    onChange={this.handleChange}
                  >
                    <option value="commit">Commit</option>
                    <option value="import">Import</option>
                    <option value="ai_thinking">AI Thinking</option>
                    <option value="human_decision">Human Decision</option>
                    <option value="other">Other</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    name="status"
                    value={status}
                    onChange={this.handleChange}
                  >
                    <option value="pending">Pending</option>
                    <option value="running">Running</option>
                    <option value="completed">Completed</option>
                    <option value="failed">Failed</option>
                    <option value="cancelled">Cancelled</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Progress</Form.Label>
                  <Form.Control
                    type="number"
                    name="progress"
                    value={progress}
                    onChange={this.handleChange}
                    min="0"
                    max="100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Agent IDs (comma-separated)</Form.Label>
                  <Form.Control
                    type="text"
                    name="agent_ids"
                    value={agent_ids}
                    onChange={this.handleChange}
                    placeholder="agent1, agent2, agent3"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Parameters (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                name="params"
                value={params}
                onChange={this.handleChange}
                rows={5}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Output (JSON)</Form.Label>
              <Form.Control
                as="textarea"
                name="output"
                value={output}
                onChange={this.handleChange}
                rows={5}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSubmit}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(null, { setK3Tasks })(K3TaskCreator); 